import { OrderPaymentStatus } from "../../../../../../../../redux/constants/OrdersPage/order";

import { paymentMethods, PaymentMethod } from "./paymentMethods";

export interface PaymentMethodsFilterOptions {
	/** Order source: phone, app, executor, dispatcher, website... */
	type?: string | null;
	checkCardId?: number | string | null;
	paymentAccountId?: number | string | null;
	paymentType?: string | null;
	paymentStatus?: string | null;
}

/**
 * Options of the payment type select in the order modal.
 *
 * Pure function (no React) so the rules can be unit-tested; the component
 * only wraps it in useMemo.
 */
export default function filterPaymentMethods(
	dataOptions: PaymentMethodsFilterOptions,
): PaymentMethod[] {
	const { type, checkCardId, paymentAccountId, paymentType, paymentStatus } =
		dataOptions;

	return paymentMethods.filter((item) => {
		if (item.name === "company_bill" && !paymentAccountId && !checkCardId) {
			return false;
		}

		if (paymentType === "company_bill") {
			if (item.name === "company_bill") return true;
			return false;
		}

		// QR-link payment turns an order of any source (dispatcher,
		// executor, website) into a card order, not only phone/app with a
		// saved card. The current value must be in the list, otherwise the
		// select renders blank on the green payment_success background.
		if (item.name === "card" && paymentType === "card") return true;

		const failed =
			paymentStatus === OrderPaymentStatus.PAYMENT_FAILED ||
			paymentStatus === OrderPaymentStatus.CARD_VALIDATION_FAILED;
		if (type && type !== "executor" && failed) {
			const phoneCard = type === "phone" && paymentType === "card";
			const appCard = type === "app" && paymentType === "card";
			const itemCash = item.name === "cash";
			const itemInvoice = item.name === "invoice";
			const arr = [
				phoneCard && itemCash,
				phoneCard && itemInvoice,
				appCard && itemCash,
				appCard && itemInvoice,
			];

			if (arr.some((flag) => flag)) return true;
		}

		if (type && item.name === "card" && type !== "executor") {
			const phoneCard = type === "phone" && paymentType === "card";
			const appCard = type === "app" && paymentType === "card";
			if (phoneCard || appCard) return true;
			return false;
		}

		if (paymentType === "invoice" || paymentType === "cash") {
			if (item.name === "invoice") return true;
			if (item.name === "cash") return true;
		}

		return false;
	});
}
